import { PasswordIndications, TextField } from "@hellocarbo/lasagne";
import { ChangeEvent, Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";

import useSignupSteps from "@/hooks/useSignupSteps";

import Template from "./Template";

const PasswordStep = ({
  password,
  setPassword,
}: {
  password: string;
  setPassword: Dispatch<SetStateAction<string>>;
}) => {
  const { t } = useTranslation(["common", "signUp"]);
  const { goToNextStep } = useSignupSteps();

  const [isValid, setIsValid] = useState(false);
  const [hasError, setHasError] = useState(false);

  const handleContinue = () => {
    if (isValid) {
      goToNextStep();
    } else {
      setHasError(true);
    }
  };

  return (
    <Template
      title={t("signUp:password.title")}
      buttonText={t("continue")}
      onClick={handleContinue}
    >
      <div className="space-y-xs">
        <TextField
          type="password"
          value={password}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            setPassword(e.target.value);
          }}
          isInvalid={hasError}
          label={t("signUp:password.label")}
          onFocus={() => setHasError(false)}
          fullWidth
        />
        <PasswordIndications
          text={t("passwordConstraints:mustContain")}
          password={password}
          setValid={setIsValid}
          isInvalid={hasError}
          constraintText={{
            minLength: t("passwordConstraints:constraints.minLength"),
            hasUppercase: t("passwordConstraints:constraints.hasUppercase"),
            hasLowercase: t("passwordConstraints:constraints.hasLowercase"),
            hasDigit: t("passwordConstraints:constraints.hasDigit"),
            hasSymbol: t("passwordConstraints:constraints.hasSymbol"),
          }}
        />
      </div>
    </Template>
  );
};

export default PasswordStep;
